const CryptoJS = require('crypto-js')

export const compareHashedStrings = (string, hashedString) => {
  if(!string) return false
  const hashedInput = CryptoJS.SHA256(string).toString()
  return hashedInput === hashedString
}